module.exports = __webpack_public_path__ + "static/dashboard2-d5a69b556cdd757a9a103b5edf1969cc.png";